import { render, staticRenderFns } from "./products.vue?vue&type=template&id=ab4043aa&scoped=true&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"
import style0 from "./products.vue?vue&type=style&index=0&id=ab4043aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4043aa",
  null
  
)

export default component.exports